<template>
    <div>
        <LoadingApp :is_full_page="true" :isLoading="isLoading" />

        <div
            v-if="response && response.status === 'error'"
            class="alert alert-danger"
            role="alert"
        >
            {{ response.message }}
        </div>
        <div
            v-if="response && response.status === 'success'"
            class="alert alert-success"
            role="alert"
        >
            {{ response.message }}<br />
            Verifique seu e-mail, caso não tenha recebido, não esqueça de
            conferir sua caixa de spam!
        </div>

        <form @submit.prevent="submit">
            <div class="row">
                <div class="col-md-6">
                    <form-group class="form-group required-field">
                        <label for="reset-email">Email</label>
                        <input
                            type="email"
                            class="form-input form-wide mb-2"
                            id="reset-email"
                            name="email"
                            placeholder="Email"
                            v-model="form.email"
                            required
                            :disabled="hasError"
                        />
                    </form-group>
                </div>

                <template v-for="field in login_fields">
                    <div
                        v-if="field.value !== 'email'"
                        :key="field.value"
                        class="col-md-6"
                    >
                        <form-group class="form-group required-field">
                            <label :for="`reset-${field.value}`">
                                {{ loginFieldLabel(field) }}
                            </label>
                            <input
                                type="text"
                                :id="`reset-${field.value}`"
                                :name="field.value"
                                class="form-input form-wide mb-2"
                                :placeholder="field.label"
                                v-model="form[field.value]"
                                v-mask="maskRegister(form.user_cpfcnpj, field)"
                                required
                            />
                        </form-group>
                    </div>
                </template>
            </div>

            <div class="form-footer" style="margin-top: unset">
                <PrimaryButton type="submit">Enviar</PrimaryButton>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CFormGroup } from "../../components/Styles/Components/styled";
import { PrimaryButton } from "../../components/Styles/Extends/styled";
import { swall } from "../../services/sweetAlert";
import LoadingApp from "../../components/LoadingApp.vue";

export default {
    name: "ForgotPassword",
    components: {
        PrimaryButton,
        LoadingApp,
        "form-group": CFormGroup,
    },
    data() {
        return {
            form: {
                email: null,
                user_cpfcnpj: null,
            },
            response: null,
            isLoading: false,
            hasError: false
        };
    },
    methods: {
        ...mapActions("clients", ["ActionForgotPassword"]),
        submit() {
            this.isLoading = true;

            this.ActionForgotPassword(this.form)
                .then((response) => {
                    this.isLoading = false;
                    if(response.data.quantity){
                        this.hasError = true
                    }
                    this.resetForm();
                    this.response = response.data;
                })
                .catch((error) => {
                    this.isLoading = false;
                    swall(error?.msg ?? error?.message ?? error);
                });
        },
        maskRegister(cpf_cnpj, field) {
            if(field.label == 'CNPJ') {
                return "##.###.###/####-##";
            }
            if(field.value == 'user_cpfcnpj') {
                if (!cpf_cnpj || cpf_cnpj.length <= 14) {
                    return "###.###.###-##";
                }
                return "##.###.###/####-##";
            }
            return ''
        },
        loginFieldLabel(field) {
            return field.value != "user_cpfcnpj"
                ? field.label.toLowerCase()
                : field.label;
        },
        resetForm() {
            this.form = {
                email: null,
                user_cpfcnpj: null,
            };
        },
    },
    computed: {
        ...mapGetters("company", ["login_fields"]),
    },
};
</script>
